<div class="verifiedEmailBanner">
  <img src="/assets/img/icons/check-green.svg" />
  <p>{{ 'txt-email-verified' | translate }}</p>
</div>
